import React from 'react';
import styled from 'styled-components';

export const ModalVideoContainer = styled.div`
  position: relative;
  display: inline-block;
  padding: 10px;
  box-shadow: 5px 5px 32px #312a3f52;
`

export const ModalVideoPlayButton = styled.svg.attrs({
  viewBox: '0 0 105 105',
  children: <path d="M52.5 0A52.5 52.5 0 10105 52.5 52.51 52.51 0 0052.5 0zM42 68V37l28 15.5z" fill="rgba(255,255,255,.6)"/>
})`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  cursor: pointer;
`
